import { render, staticRenderFns } from "./OverlayNav.vue?vue&type=template&id=0f2ddece&scoped=true&"
import script from "./OverlayNav.vue?vue&type=script&lang=js&"
export * from "./OverlayNav.vue?vue&type=script&lang=js&"
import style0 from "./OverlayNav.vue?vue&type=style&index=0&id=0f2ddece&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2ddece",
  null
  
)

export default component.exports